import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslator } from '../../i18n/useTranslator';

import './VisibilityButton.scss';

const VisibilityButton = (props) => {
    const { error, onClick, isVisible, isFocused } = props;
    const translate = useTranslator('userInterface', 'password');

    const classes = classNames('VisibilityButton', { 'has-input-focus': isFocused, error });

    return (
        <input
            type="button"
            className={classes}
            onClick={onClick}
            value={isVisible ? translate('hide', 'Hide') : translate('show', 'Show')}
        />
    );
};

VisibilityButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isFocused: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    error: PropTypes.object,
};

export default VisibilityButton;
